module.exports = require("@swa-ui/personal-info/src/form/PassengerAccommodationsFormFields/PlacementInfoLabel/PlacementInfoLabel.module.scss");